<template>
  <RouterView name="header" class="header-router-view"></RouterView>
  <RouterView></RouterView>
  <div id="qiankun_u"></div>
</template>
<script lang="ts"></script>

<style lang="less">
:root {
  --app-background-color: #050c23;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background-color: var(--app-background-color);
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.el-popper {
  border: none !important;
}
.product-content {
  background: #fff !important;
  inset: unset !important;
  top: 80px !important;
  left: 0 !important;
  .el-popper__arrow::before {
    background: #fff !important;
    border-color: #fff !important;
  }
}
.el-popper__arrow::before {
  background: #38405b !important;
  border-color: #38405b !important;
}
// #qiankun_u {
//   flex-grow: 1;
//   overflow-y: scroll;
// }
</style>
